module.exports = "/packs/media/images/meeting-0a798a456d87f7f51af499f990426ac4.png";